/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-08-15 17:27:18
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-08-14 15:38:30
 */

import { flatten, flattenDeep } from "lodash";

/**
 * 根据条件分组
 * @param {*} [array=[]]
 * @param {Func} [callback=() => {}]
 * @param {boolean} [isMap=false] ,返回对象|数组
 * @returns {object|array}
 */
function groupBy(array = [], callback = () => { }, isMap = false) {
  const result = array.reduce((prev, current) => {
    let group = callback(current);
    prev[group] = (prev[group] || []).concat(current)
    return prev
  }, {})
  // 返回对象格式
  if (isMap) return result
  // 返回数组格式的数据
  return Object.keys(result).map(function (group) {
    return result[group];
  });
}

// label样式
const labelStyle = {
  fontSize: '80%',
  lineHeight: 20,
  color: '#fff',
  align: 'center',
  fontFamily: 'AlibabaPuHuiTi'
}

// createPie({ inner: '70%', outer: '95%', list: labelList, colors: colorList }, 3, labelList.length > 1 ),
// createPie({ inner: '50%', outer: '72%', list: labelList, colors: colorList }, 2),
// createPie({ inner: '28%', outer: '50%', list: labelList, colors: colorList }, 1),
// createPie({ inner: '0%', outer: '28%', list: labelList, colors: colorList }, 0)
const floorYAxis = {
  '3': [
    ['66%', '95%'],
    ['33%', '66%'],
    ['0%', '33%'],
  ],
  '4': [
    ['70%', '95%'],
    ['50%', '72%'],
    ['28%', '50%'],
    ['0%', '28%'],
  ]
}


/**
 * 根据数组计算label角度
 * @param {Number} length 数组长度
 * @param {Number} index 当前位置
 * @param {Number} groupList 父数组长度
 * @param {Number} groupIndex 父数组当前位置
 */
const calcAngle = (length, index, groupList = 3, groupIndex) => {
  // 根据父数组长度将图平分
  const pieNum = 360 / groupList
  // 根据数组长度获得每个数据的平均角度
  const baseAngle = pieNum / length
  // 当前数据角度 + 居中便宜角度 + 当前板块开始角度
  return baseAngle * index + baseAngle / 2 + groupIndex * pieNum// + typeGrouRange(type)
}



// [
//   ['#876034', '#9c7d59', '#bda78d', '#e0d6c7'],
//   ['#0b4b4b', '#41726f', '#94aba5', '#d0d3cc'],
//   ['#ab1d2b', '#b95055', '#d49897', '#e3cbc7'],
//   ['#4a4a4b', '#6c6a6a', '#9f9d98', '#d7d3cb'],
//   ['#1d5d9d', '#4f7faf', '#9bb1c6', '#d1d7d7'],
// ]

/**
 * 生成扇形图
 * @param {*} param0 
 * @param {*} opacity 
 * @param {*} label 
 */
const createPie = ({ inner, outer, list, colors }, opacity = 0, label = false) => {
  const colorList = colors

  const dataList = list ? list : ['类别1', '类别2', '类别3', '类别4']
  const numChinese = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'].splice(0, dataList.length)
  return {
    type: 'pie',
    radius: [inner, outer],
    avoidLabelOverlap: false,
    label: {
      normal: {
        show: !!label,
        formatter: '{b|{b}}',
        padding: [8, 10, 0, 10],
        borderRadius: 4,
        // fontFamily: 'AlibabaPuHuiTi',
        rich: {
          bh: {
            fontSize: 17,
            lineHeight: 20,
            align: 'left',
            color: '#4b4a4a',
            fontWeight: 'bold',
            fontFamily: 'AlibabaPuHuiTi'

          },
          b: {
            fontSize: 16,
            lineHeight: 33,
            fontWeight: 'bold',
            color: '#4b4a4a',
            align: 'left',
            fontFamily: 'AlibabaPuHuiTi'
          },
        }
      }
    },
    labelLine: {
      normal: {
        show: !!label,
        lineStyle: {
          color: '#000'
        }
      }
    },
    legendHoverLink: false,
    hoverAnimation: false,
    silent: false,
    data: [
      ...dataList.map((item, index) => ({
        value: 100,
        name: item,
        label: {
          normal: {
            formatter: `{bh|认知方向${numChinese[(index + 1) % numChinese.length]}：} \n{b|{b}}`,
            backgroundColor: colorList[index % colorList.length][opacity],
          }
        },
        itemStyle: {
          normal: {
            color: colorList[index % colorList.length][opacity],
          }
        }
      }))
    ]
  }
}

export function createKeyWordChart({
  list, labelList,
  dateRangeText, colorList,
  fontSizes = [20, 18, 16, 14],
  floor = 4
}) {
  floor = Number(floor)
  const _list = list.slice(0)
  _list.forEach((item, outerIndex) => {
    const floorList = groupBy(item, (record) => record.floor)
    floorList.filter((_v, i) => i < floor).forEach(element => {
      element.forEach((that, i) => {
        that.x = calcAngle(element.length, i, _list.length, outerIndex)
        that.y = that.floor === 0 ? 75 : that.floor * 100 + 60 + (floor === 3 ? 60 : 0)
        that.size = that.floor
      })
    })
  })

  return {
    title: {
      text: '认知关键词',
      top: 0,
      left: 50,
      subtext: '数据来源：数榜舆图\n时间窗口：' + dateRangeText,
      subtextStyle: {
        lineHeight: 20
      }
    },
    polar: {
      radius: '97%'
    },
    grid: {
      borderWidth: 3,
      borderColor: '#f00',
      top: '20%',
      right: '5%',
      bottom: '10%',
      left: '5%',
    },
    toolbox: {
      right: 20,
      feature: {
        saveAsImage: {
          name: '认知关键词_数榜舆图',
          pixelRatio: 2
        },
      }
    },
    angleAxis: {
      type: 'value',
      data: Array(360).fill(1).map((item, i) => i),
      max: 360,
      min: 0,
      interval: 360 / labelList.length,
      axisLabel: {
        show: false
      },
      axisLine: {
        show: false
      },
      splitLine: {
        show: labelList.length > 1,
      },
      axisTick:{//一个一个的小刻度
        show:false
    },
      
    },
    radiusAxis: {
      type: 'value',
      min: 0,
      max: 400,
      axisLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: '#ccc'
        }
      }
    },
    series: [{
      coordinateSystem: 'polar',
      angleAxisIndex: 0,
      radiusAxisIndex: 0,
      name: 'scatter',
      type: 'scatter',
      symbolSize: 1,
      data: flattenDeep(list || []).map(item => {
        return ({
          value: [item.y, item.x, item.name, item.floor, item.value], //item,
          label: {
            normal: {
              // fontSize: item.floor === 0 ? '26' : item.floor === 1 ? 22 : 20 - item.floor * 2,
              fontSize: fontSizes[item.floor],
              fontWeight: item.floor === 0 ? 600 : 400,
              color: item.floor === 0 ? '#fff' : '#000'
            }
          }
        })
      }),

      label: {
        normal: {
          show: true,
          fontSize: 18,
          color: '#333',
          fontFamily: 'AlibabaPuHuiTi',
          formatter: item => {
            const titleStyle = item.value[3] === 0 ? `tit0|${item.value[4]}` : `titnum|${item.value[4]}`
            return `{at|${item.value[2]}} \n{${titleStyle}}`
          },
          align: 'center',
          rich: {
            tit0: {
              ...labelStyle
            },
            titnum: {
              ...labelStyle,
              color: '#333',
            }
          }
        }
      }
    },
    ...Array(floor).fill(1).map((v, i) => {
      const coords = floorYAxis[floor]
      return createPie({
        inner: coords[i][0],
        outer: coords[i][1],
        list: labelList,
        colors: colorList
      }, floor - (i + 1), i === 0 && labelList.length > 1)
    }),
      // createPie({ inner: '70%', outer: '95%', list: labelList, colors: colorList }, 3, labelList.length > 1 ),
      // createPie({ inner: '50%', outer: '72%', list: labelList, colors: colorList }, 2),
      // createPie({ inner: '28%', outer: '50%', list: labelList, colors: colorList }, 1),
      // createPie({ inner: '0%', outer: '28%', list: labelList, colors: colorList }, 0)
    ]
  }
}


// WEBPACK FOOTER //
// src/routes/customChart/KeyValuePie/scatter.js